import { StreetTypeFactory } from '@/Domain/Localization/StreetType/StreetTypeFactory'
import { AxiosStreetTypeJsonData } from './AxiosStreetTypeJsonData'
import { StreetType, StreetTypeName } from '@/Domain/Localization/StreetType'

export class AxiosStreetTypeFactory implements StreetTypeFactory<AxiosStreetTypeJsonData> {
  makeStreetType (data: AxiosStreetTypeJsonData): StreetType {
    return new StreetType(
      data.code,
      new StreetTypeName(data.name)
    )
  }
}
